export const SELECT_HORIZONTAL_TIME_DOMAIN = 'selectHorizontalTime';
